/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FeatureFlagsResponse } from '../models/FeatureFlagsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FeatureFlagsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get the feature flags
     * Returns the state of every feature flag. Public endpoint: the apps read it at startup, before login.
     * @returns FeatureFlagsResponse
     * @throws ApiError
     */
    public featureFlagsControllerGetStates(): CancelablePromise<FeatureFlagsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/feature-flags',
        });
    }
}
